import {h, Fragment} from "preact"
import { useActions, useFacet, useAppStateSelector, pick } from "@nosto/preact"
import { useEffect, useMemo, useState } from "preact/hooks"
import { lumberFinishFilters, tier3Map } from "../../config"

function VisualFilter({ element, facet, activeFacet, activeFilters }) {
    const { updateSearch } = useActions();
    const valuesToUpdate = useMemo(() => {
        const data = element.getAttribute('data-filters');
        const parsedData = data && typeof data === 'string' ? JSON.parse(data) : [];
        return parsedData.map(data => (
            facet.field === "customFields.metafields-marketing_category_tier_3" && tier3Map[data] 
                ? tier3Map[data] 
                : data
        ))
    }, []);

    useEffect(() => {
        const valuesAreActive = activeFacet ? valuesToUpdate.every(v => activeFacet.value.includes(v)) : false;
        element.className = valuesAreActive
            ? "ease-in-out duration-300 px-2xs pt-2xs rounded-sm border overflow-hidden bg-p-lightest hover:border-t-foreground-secondary hover:underline border-t-foreground-secondary underline"
            : "ease-in-out duration-300 px-2xs pt-2xs rounded-sm border overflow-hidden bg-p-lightest hover:border-t-foreground-secondary hover:underline border-p-lightest"
    }, [ activeFacet, valuesToUpdate, element ])

    useEffect(() => {
        const handleClick = (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            const valuesAreActive = activeFacet ? valuesToUpdate.every(v => activeFacet.value.includes(v)) : false;
            const newFilter = !activeFacet
                ?   { field: facet.field, value: valuesToUpdate }
                :   {
                        ...activeFacet,
                        value: [
                            ...activeFacet.value.filter(v => !valuesToUpdate.includes(v)), 
                            ...(!valuesAreActive ? valuesToUpdate : [])
                        ]
                    }

            updateSearch({
                products: {
                    filter: [
                        ...(activeFilters?.filter(v => v.field !== facet.field) ?? []),
                        ...(newFilter?.value?.length ? [ newFilter ] : [])
                    ]
                }
            })
        }
        
        element.addEventListener('click', handleClick)
        return () => element.removeEventListener('click', handleClick)
    }, [ activeFacet, element, valuesToUpdate, activeFilters, facet ])

    return null
}

export default function VisualFacet({ facet }) {
    const { query } = useAppStateSelector(state => pick(state, "query"))
    const activeFacet = useMemo(() => query.products?.filter?.find(f => f.field === facet.field), [ query.products?.filter, facet.field ]);
    const [ toggles, setToggles ] = useState([]);

    useEffect(() => {
        const facetFieldSelector = facet.field.replace('customFields.metafields-', '');
        setToggles(Array.from(document.querySelectorAll(`button[visual-filter][data-filter-key$="${facetFieldSelector}"]`)))
    }, [])

    return (toggles?.length > 0 && (
        <>
            {toggles.map((toggleEl, index) => (
                <VisualFilter 
                    key={index}
                    facet={facet}
                    element={toggleEl}
                    activeFacet={activeFacet}
                    activeFilters={query.products?.filter}
                />
            ))}
        </>
    ))
}
